import { POST } from './Clients';

const FRONTEND_APIS_PREFIX = '/marketplace/frontend-apis/v1';

export async function postShieldAttributes(body) {
  return POST({ url: `${FRONTEND_APIS_PREFIX}/shield-attributes`, body, isAuth: false });
}

const SHIELD_RESULT_URL = `${process.env.NEXT_PUBLIC_MONITORING_BUYMED_DOMAIN}/monitoring/collector/v1/shield/result`;

export async function postShieldResult(body) {
  return POST({ url: SHIELD_RESULT_URL, body, isAuth: false });
}

export default {
  postShieldAttributes,
  postShieldResult,
};
